import React, {useCallback, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setRangeEndDate, setRangeStartDate} from "../../actions/ui";
import DatePicker from "../DatePicker";
import TimePicker from "../TimePicker";
import Calendar from "../Calendar";
import PeriodContainer from "./components/PeriodContainer";
import {Alert, Dialog, DialogContent, Typography,} from "@mui/material";
import Button from "../../Components/baseComponents/Button/Button";
import useStyles from "./useStyles";
import CrossSvg from "../../icons/Cross";
import Box from "@mui/material/Box";
import Snackbar from "@mui/material/Snackbar";

const mapStateToProps = (state) => {
  const { ui: { rangeStartDate, rangeEndDate } = {} } = state;
  return {
    rangeStartDate,
    rangeEndDate,
  };
};

const DateRanger = ({ label, open, onClose }) => {
  const classes = useStyles();

  const { rangeStartDate, rangeEndDate } = useSelector(mapStateToProps);

  const dispatch = useDispatch();

  // накопительные состояния выбранных дат !!!
  const [dateStart, setDateStart] = useState(rangeStartDate);
  const [dateEnd, setDateEnd] = useState(rangeEndDate);

  // даты для календаря !!!
  const [dateStartCalendar, setDateStartCalendar] = useState(rangeStartDate);
  const [dateEndCalendar, setDateEndCalendar] = useState(rangeEndDate);

  const [openSnackBar, setOpenSnackBar] = useState(false);

  const setStart = useCallback((date) => {
    setDateStart(date);
  },[]);

  const setEnd = useCallback((date) => {
    setDateEnd(date);
  },[]);

  const setTimeStart = useCallback((timeStart) => {
    setDateStart(timeStart);
  },[])

  const setTimeEnd = useCallback((timeEnd) => {
    setDateEnd(timeEnd);
  },[])

  const onChangeDateStartCalendar = useCallback((newDateStartCalendar) => {
      setDateStartCalendar(newDateStartCalendar)
  }, [])

  const onChangeDateEndCalendar = useCallback((newDateEndCalendar) => {
    setDateEndCalendar(newDateEndCalendar)
  }, [])

  // изменить значения выбранного периода только при кнопке - сохранить !!!
  const saveRangeSettings = () => {
    /* проверка корректного диапазона !!! */
    if (dateStart > dateEnd) {
      setOpenSnackBar(true)
      return
    }
    dispatch(setRangeStartDate(dateStart))
    dispatch(setRangeEndDate(dateEnd))
    onClose()
  }

  const handleCloseSnackBar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackBar(false);
  };

  const periodContainerClickHandler = useCallback((period) => {
    setDateStart(period?.from);
    setDateEnd(period?.to);
    setDateStartCalendar(period?.from)
    setDateEndCalendar(period?.to)
  },[])

  const onChangeByCalendarDateHandler = useCallback((newPeriod) => {

    if (!newPeriod || !newPeriod.length)  return

    const newDateStart = newPeriod[0]
    const newDateEnd = newPeriod[1]

    if (newDateStart && newDateEnd) {

      setDateStart(newDateStart.toDate())
      setDateStartCalendar(newDateStart.toDate())

      setDateEnd(newDateEnd.toDate())
      setDateEndCalendar(newDateEnd.toDate())
    }

    if (!newDateEnd) {

      /* в случае, если возвращается только одна дата из массива, она может быть как датой начала, так и датой окончания,
      * поэтому высчитываем актуальные минимальную и максимальную даты !!! */

      const minDate = dateEnd < newDateStart?.toDate() ? dateEnd : newDateStart?.toDate()
      const maxDate = dateEnd > newDateStart?.toDate() ? dateEnd : newDateStart?.toDate()

      setDateStart(minDate)
      setDateStartCalendar(minDate)

      setDateEnd(maxDate)
      setDateEndCalendar(maxDate)
    }
  }, [dateStart, dateEnd])

  return (
      <>
        <Dialog
          open={open}
          onClose={onClose}
          aria-labelledby="responsive-dialog-title"
          className={classes.dialog}
        >
          <DialogContent className={classes.dialogContent}>
            <Typography className={classes.history}>Выберите период</Typography>
            <div className={classes.line} />
            <PeriodContainer periodContainerClickHandler={periodContainerClickHandler} />
            <div className={classes.dataAndTimeContainer}>
              <div className={classes.dataAndTimeInputs}>
                <DatePicker
                    onAcceptCallback={setStart}
                    onChangeCallback={onChangeDateStartCalendar}
                    value={dateStart} />
                <div className={classes.lineY}></div>
                <TimePicker onChangeCallback={setTimeStart} value={dateStart} />
              </div>
              <div className={classes.dataAndTimeInputs}>
                <DatePicker
                    onAcceptCallback={setEnd}
                    onChangeCallback={onChangeDateEndCalendar}
                    value={dateEnd} />
                <div className={classes.lineY}></div>
                <TimePicker onChangeCallback={setTimeEnd} value={dateEnd} />
              </div>
            </div>
            <Calendar
                dateFrom={dateStartCalendar}
                dateTo={dateEndCalendar}
                onChange={onChangeByCalendarDateHandler}
            />
            {/*<ContainerBottomInformation />*/}
          </DialogContent>
          <Button className={classes.cross} autoFocus onClick={onClose}>
            <CrossSvg />
          </Button>
          <Box className={classes.saveRangeSettingsWrapper}>
            <Button className={classes.saveRangeSettings} onClick={saveRangeSettings}>
              Сохранить
            </Button>
          </Box>
        </Dialog>

        <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={openSnackBar}
            onClose={handleCloseSnackBar}
            key={'top' + 'center'}
            autoHideDuration={5000}
        >
          <Alert severity="error">Некорректный период</Alert>
        </Snackbar>

      </>
  );
};

export default React.memo(DateRanger);
